import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';

import { AlertLiteComponent, AlertModule } from '@lockton-apps/shared/ui/lui';

import { AlertTypeComponent } from './alert-type.component';

@NgModule({
  declarations: [AlertTypeComponent],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'alert',
          component: AlertTypeComponent,
          defaultOptions: {
            props: {
              level: 'elevated',
            },
          },
        },
      ],
    }),
    AlertModule,
    AlertLiteComponent,
  ],
})
export class AlertTypeModule {}
